import React, { useEffect, useState } from "react";
import {
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBTypography,
  MDBSpinner,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBInput,
} from "mdb-react-ui-kit";

function StaffManagementTab() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOption, setSortOption] = useState("firstname");

  const [createModal, setCreateModal] = useState(false);
  const toggleShow = () => setCreateModal(!createModal);

  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    age: "",
    role: "staff",
  });
  const [formError, setFormError] = useState("");

  const fetchStaff = async () => {
    setLoading(true);
    try {
      const response = await fetch("https://krizkhen-floral-design.onrender.com/api/users/get-all-users");
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      setStaff(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStaff();
  }, []);

  const handleCreateUser = async () => {
    const { email, password, firstname, lastname, age, role } = formData;

    if (!email || !password || !firstname || !lastname || !age) {
      setFormError("Please fill in all fields");
      return;
    }

    try {
      const response = await fetch("https://krizkhen-floral-design.onrender.com/api/users/create-user", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, firstname, lastname, age, role }),
      });

      const data = await response.json();

      if (!response.ok) throw new Error(data.error || "Failed to create user");

      toggleShow();
      setFormData({
        firstname: "",
        lastname: "",
        email: "",
        password: "",
        age: "",
        role: "staff",
      });
      fetchStaff();
    } catch (err) {
      setFormError(err.message);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <MDBSpinner role="status">
          <span className="visually-hidden">Loading...</span>
        </MDBSpinner>
      </div>
    );
  }

  if (error) {
    return (
      <MDBTypography tag="p" className="text-danger text-center mt-4">
        Error: {error}
      </MDBTypography>
    );
  }

  const sortedStaff = [...staff].sort((a, b) => {
    if (!sortOption) return 0;

    if (sortOption === "createdAt") {
      return new Date(a.createdAt) - new Date(b.createdAt);
    }

    return a[sortOption]?.localeCompare(b[sortOption]);
  });

  return (
    <div className="mt-4 w-100">


      {/* Title and Controls Row */}
      <MDBRow className="align-items-center mb-4">
        <MDBCol>
          <MDBTypography tag="h1" className="custom-font" style={{ color: "#A78D79" }}>
            Staff Management
          </MDBTypography>
        </MDBCol>

        <MDBCol md="auto" className="d-flex align-items-center justify-content-end ms-auto">
          <div className="d-flex align-items-center gap-3">
            <div className="d-flex align-items-center gap-2">
              <MDBTypography className="mb-0">Sort by:</MDBTypography>
              <select
                className="form-select"
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
                style={{ width: 'auto' }}
              >
                <option value="firstname">First Name</option>
                <option value="lastname">Last Name</option>
                <option value="role">Role</option>
                <option value="createdAt">Date Created</option>
              </select>
            </div>

            <MDBBtn style={{backgroundColor:'#A78D79'}} onClick={toggleShow}>
              CREATE USER
            </MDBBtn>
          </div>
        </MDBCol>
      </MDBRow>


      {/* Staff Table */}

      <div className="mt-3" style={{ width: "100%", overflowX: "auto" }}>
        <MDBTable bordered hover responsive>
          <MDBTableHead>
            <tr>
              <th className="fw-bold">#</th>
              <th className="fw-bold">First Name</th>
              <th className="fw-bold">Last Name</th>
              <th className="fw-bold">Email</th>
              <th className="fw-bold">Role</th>
              <th className="fw-bold">Age</th>
              <th className="fw-bold">Date Created</th>
            </tr>
          </MDBTableHead>
          <MDBTableBody>
            {sortedStaff.length > 0 ? (
              sortedStaff.map((s, index) => (
                <tr key={s._id}>
                  <td>{index + 1}</td>
                  <td>{s.firstname}</td>
                  <td>{s.lastname}</td>
                  <td>{s.email}</td>
                  <td>{s.role}</td>
                  <td>{s.age}</td>
                  <td>{new Date(s.createdAt).toLocaleDateString()}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="7" className="text-center">
                  No staff found
                </td>
              </tr>
            )}
          </MDBTableBody>
        </MDBTable>
      </div>

      {/* Create User Modal */}
      <MDBModal open={createModal} tabIndex="-1">
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Create New User</MDBModalTitle>
              <MDBBtn className="btn-close" color="none" onClick={toggleShow}></MDBBtn>
            </MDBModalHeader>

            <MDBModalBody>
              <MDBInput
                className="mb-3"
                label="First Name"
                value={formData.firstname}
                onChange={(e) => setFormData({ ...formData, firstname: e.target.value })}
              />
              <MDBInput
                className="mb-3"
                label="Last Name"
                value={formData.lastname}
                onChange={(e) => setFormData({ ...formData, lastname: e.target.value })}
              />
              <MDBInput
                className="mb-3"
                label="Email"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              />
              <MDBInput
                className="mb-3"
                label="Password"
                type="password"
                value={formData.password}
                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              />
              <MDBInput
                className="mb-3"
                label="Age"
                type="number"
                value={formData.age}
                onChange={(e) => setFormData({ ...formData, age: e.target.value })}
              />

              {formError && <p className="text-danger small mb-0">{formError}</p>}
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color="danger" onClick={toggleShow}>
                Cancel
              </MDBBtn>
              <MDBBtn color="success" onClick={handleCreateUser}>
                Create
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </div>
  );
}

export default StaffManagementTab;
